import { Component, OnInit } from '@angular/core';
import { DataTaskService } from '@app/core/services/data-task.service';
import { StateService } from '@app/core/services/state.service';

@Component({
    selector: 'tt-video-tutorials',
    templateUrl: './video-tutorials.component.html',
    styleUrls: ['./video-tutorials.component.css'],
})
export class VideoTutorialsComponent implements OnInit {
    public videos: EnrichedVideoItem[] = [];

    public selectedVideo?: EnrichedVideoItem;

    public languages: LanguageItem[] = [];

    public get?: VideoTutorialsGet;

    public params: { argtype: string; argvalue: string };

    constructor(public state: StateService, private datatask: DataTaskService) {
        this.params = state.getStateParams() as { argtype: string; argvalue: string };
    }

    public trackById(_: number, video: (typeof this.videos)[0]) {
        return video.vt_keyno;
    }

    private enrichVideoItem = (item: VideoItem): EnrichedVideoItem => {
        return { ...item, videoId: this.getVideoId(item.full_url), thumbnail: this.getThumbnail(item.full_url) };
    };

    public async loadVideos() {
        this.videos = (await this.getVideos()).map(this.enrichVideoItem);

        if ((!this.selectedVideo || !this.videos.some((video) => '' + video.vt_keyno === '' + this.selectedVideo?.vt_keyno)) && this.videos.length > 0) {
            this.selectedVideo = this.videos[0];
        }
    }

    private async getVideos(): Promise<VideoItem[]> {
        if (!!this.get) {
            return this.datatask.Post(3791, this.get);
        }

        throw Error('Get not loaded');
    }

    private async loadGet() {
        this.get = (await this.datatask.Post(3792, this.params))[0];
    }

    private async loadLanguages() {
        this.languages = await this.datatask.Post(57);
    }

    private async init() {
        await this.loadGet();
        this.loadLanguages();
        await this.loadVideos();
    }

    ngOnInit(): void {
        this.init();
    }

    private getThumbnail(src: string) {
        return `https://i.ytimg.com/vi/${this.getVideoId(src)}/hqdefault.jpg`;
    }

    private getVideoId(src: string) {
        return src.split('=').at(-1) ?? '';
    }
}

interface VideoTutorialsGet {
    language_id: string;
    searchtext: string;
    argtype: string;
    argvalue: string;
    show_all: '1' | '0';
}
interface VideoItem {
    vt_keyno: string;
    video_title: string;
    video_description: string;
    full_url: string;
    has_been_read: '1' | '0';
}

interface EnrichedVideoItem extends VideoItem {
    thumbnail: string;
    videoId: string;
}

interface LanguageItem {
    item_id: string;
    item_name: string;
    currentlanguage: string;
    google_language_id: string;
    orderby: string;
}
